import {
  ActionIcon,
  Alert,
  Box,
  Button,
  Center,
  FileInput,
  Group,
  Image,
  Modal,
  NumberInput,
  Text,
  TextInput,
  Title,
} from "@mantine/core";

import { useDisclosure } from "@mantine/hooks";
import {
  IconAlertCircle,
  IconPlus,
  IconQrcode,
  IconTrash,
  IconX,
} from "@tabler/icons-react";
import React, { useReducer, useState } from "react";
import logo from "../../assets/logo.png";

import { notifications } from "@mantine/notifications";
import { url } from "../settings/linkUrl";

interface dataremove {
  nameBtn?: string;
  onLoadPage: () => any;
}

export default function AppModelConfrimRemove({
  onLoadPage,
  nameBtn,
}: dataremove) {
  const [opened, { open, close }] = useDisclosure(false);

  const funcSubmit = () => {
    close();
    onLoadPage();
  };

  return (
    <>
      <Modal
        opened={opened}
        onClose={close}
        size="sm"
        centered
        title={`ยืนยัน${nameBtn}ข้อมูล`}
        transitionProps={{
          transition: "fade",
          duration: 300,
          timingFunction: "linear",
        }}
      >
        <Text fz="sm">ท่านต้องการลบข้อมูลหรือไม่ ?</Text>

        <Group justify="flex-end" mt="md">
          <Button onClick={funcSubmit}>ยืนยัน</Button>
          <Button color="red" onClick={close}>
            ยกเลิก
          </Button>
        </Group>
      </Modal>
      <Button
        leftSection={<IconX />}
        variant="gradient"
        gradient={{ from: "orange", to: "red" }}
        onClick={open}
      >
        {nameBtn}
      </Button>
    </>
  );
}
